// import axios from "../net/axios";
import jwtDecode from "jwt-decode";
// import auth from "@/app/auth";

export default {
  // getToken(authCode) {
  //   return axios.getIdToken(authCode);
  // },
  checkTokenAvailability(idToken) {
    if (!idToken) {
      return false;
    }
    const decodeToken = this.parsingToken(idToken);
    var current_time = new Date().getTime() / 1000;

    if (current_time > decodeToken.exp) {
      return false;
    } else {
      return true;
    }
  },
  parsingToken(idToken) {
    if (idToken) {
      var decoded = jwtDecode(idToken);
      return decoded;
    }
  },
  getUserRole(idToken) {
    var userRoleList = this.parsingToken(idToken)["cognito:groups"];
    if (userRoleList && userRoleList.indexOf("Admin") > -1) {
      return 0;
    } else {
      return 1;
    }
  },
  getUserName(idToken) {
    const decode = this.parsingToken(idToken);
    return decode.email;
  }
};
